<div class="dialog-header">
  <h2 mat-dialog-title>{{ data.action === 'APPROVE' ? 'Принять заявку' : 'Отклонить заявку' }}</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="app-info">
    <p><strong>Заявка №:</strong> {{ data.application.applicationNumber }}</p>
    <p><strong>Компания:</strong> {{ data.application.companyName }}</p>
  </div>

  <form class="form-content">
    <div class="field-wrapper">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>ПИН</mat-label>
        <input matInput [(ngModel)]="personIdnp" name="personIdnp" required
               maxlength="14" (input)="onNumericInput($event, 'personIdnp')">
      </mat-form-field>
      @if (getFieldError('personIdnp')) {
        <div class="field-error">{{ getFieldError('personIdnp') }}</div>
      }
    </div>

    <div class="field-wrapper">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>ИНН организации</mat-label>
        <input matInput [(ngModel)]="organizationInn" name="organizationInn" required
               maxlength="14" (input)="onNumericInput($event, 'organizationInn')">
      </mat-form-field>
      @if (getFieldError('organizationInn')) {
        <div class="field-error">{{ getFieldError('organizationInn') }}</div>
      }
    </div>

    @if (data.action === 'REJECT') {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Причина отклонения</mat-label>
        <textarea matInput [(ngModel)]="reason" name="reason" rows="3" required></textarea>
      </mat-form-field>
    }
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Отмена</button>
  <button mat-raised-button
          [color]="data.action === 'APPROVE' ? 'primary' : 'warn'"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      {{ data.action === 'APPROVE' ? 'Подписать и принять' : 'Подписать и отклонить' }}
    }
  </button>
</mat-dialog-actions>
